var _rect, _path, _path2, _circle, _rect2, _rect3, _circle2, _circle3, _circle4, _circle5, _rect4, _rect5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.475 406L242.786 386.022C216.446 362.714 194.67 342.608 177.458 325.703C160.246 308.798 146.554 293.623 136.383 280.176C126.212 266.729 119.105 254.371 115.063 243.101C111.021 231.831 109 220.305 109 208.523C109 184.447 117.215 164.341 133.645 148.204C150.075 132.068 170.547 124 195.061 124C208.623 124 221.532 126.817 233.789 132.452C246.046 138.087 256.608 146.027 265.475 156.272C274.342 146.027 284.904 138.087 297.162 132.452C309.419 126.817 322.328 124 335.889 124C360.404 124 380.876 132.068 397.306 148.204C413.736 164.341 421.951 184.447 421.951 208.523C421.951 220.305 419.93 231.831 415.888 243.101C411.845 254.371 404.739 266.729 394.568 280.176C384.397 293.623 370.705 308.798 353.493 325.703C336.281 342.608 314.504 362.714 288.164 386.022L265.475 406Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.598 406L365.208 371.61",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331.677,
    cy: 319.165,
    r: 58.7012,
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 217.426,
    y: 154,
    width: 53.1369,
    height: 123.639,
    rx: 26.5685,
    transform: "rotate(45 217.426 154)",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 189.387,
    y: 182.208,
    width: 52.5198,
    height: 43.8515,
    transform: "rotate(45 189.387 182.208)",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.911,
    cy: 202.95,
    r: 5.23318,
    transform: "rotate(45 191.911 202.95)",
    fill: "#1C1B1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.085,
    cy: 217.123,
    r: 5.23318,
    transform: "rotate(45 206.085 217.123)",
    fill: "#1C1B1F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.386,
    cy: 215.474,
    r: 5.23318,
    transform: "rotate(45 179.386 215.474)",
    fill: "#1C1B1F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.56,
    cy: 229.648,
    r: 5.23318,
    transform: "rotate(45 193.56 229.648)",
    fill: "#1C1B1F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 191.573,
    width: 53.1369,
    height: 123.639,
    rx: 26.5685,
    transform: "rotate(-45 130 191.573)",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 158.208,
    y: 219.613,
    width: 52.5198,
    height: 43.8515,
    transform: "rotate(-45 158.208 219.613)",
    fill: "#D9D9D9",
    stroke: "#1C1B1F",
    strokeWidth: 10
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.949,
    cy: 217.089,
    r: 5.23318,
    transform: "rotate(-45 178.949 217.089)",
    fill: "#1C1B1F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.123,
    cy: 202.915,
    r: 5.23318,
    transform: "rotate(-45 193.123 202.915)",
    fill: "#1C1B1F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.474,
    cy: 229.613,
    r: 5.23318,
    transform: "rotate(-45 191.474 229.613)",
    fill: "#1C1B1F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.647,
    cy: 215.439,
    r: 5.23318,
    transform: "rotate(-45 205.647 215.439)",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/내과_심장사상충감염.e779014761be0552964830f02fb7779f.svg";
export { ForwardRef as ReactComponent };